<template>
    <div class="vue-survey-wrapper vue-survey" v-if="!hide">
        <div class="survey-content">
            <slot></slot>

            <div class="button-wrapper" v-if="!hideButtons">
                <button class="btn btn-primary" @click="handleSubmit">{{ submitText }}</button>
                <button class="btn" @click="handleClose">{{ closeText }}</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "SurveyWrapper",

    props: {
        webformId: {
            type: String,
            required: true,
        },
        surveyEventBus: {
            type: Object,
            required: true
        },
        hideButtons: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            hide: false,
            submitText: Drupal.t('Submit'),
            closeText: Drupal.t('Close'),
        }
    },

    computed: {
        surveyShowedCookieName() {
            return `survey_showed_${this.webformId}`
        }
    },

    mounted() {
        this.surveyEventBus.$on('survey-finished', () => {
            this.hide = true;
            this.$cookie.set('survey-finished', this.webformId, 30)
        });

        let surveyShowedCookie = this.$cookie.get(this.surveyShowedCookieName);
        let surveyFinishCookie = this.$cookie.get('survey-finished');
        let showTimes = _.isEmpty(surveyShowedCookie) ? 1 : parseInt(surveyShowedCookie) + 1;

        if (!_.isEmpty(surveyFinishCookie) && surveyFinishCookie === this.webformId) {
            this.hide = true;
        }

        if (showTimes > 5) {
            this.hide = true;
            return;
        }

        this.$cookie.set(this.surveyShowedCookieName, showTimes, 30);
    },

    methods: {
        handleSubmit() {
            this.$emit('submit');
        },

        handleClose() {
            this.$emit('close');
            this.hide = true;
        }
    }
}
</script>